var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12.6667C16.3682 12.6667 16.6666 12.9652 16.6666 13.3334V17.3334C16.6666 17.7015 16.3682 18 16 18C15.6318 18 15.3333 17.7015 15.3333 17.3334V13.3334C15.3333 12.9652 15.6318 12.6667 16 12.6667Z",
    fill: "#CE9C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 22.6667C16.7364 22.6667 17.3334 22.0697 17.3334 21.3333C17.3334 20.597 16.7364 20 16 20C15.2636 20 14.6667 20.597 14.6667 21.3333C14.6667 22.0697 15.2636 22.6667 16 22.6667Z",
    fill: "#CE9C0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2761 5.61572C15.0494 4.30111 16.9505 4.30111 17.7238 5.61572L28.7259 24.3193C29.5102 25.6526 28.5489 27.3334 27.0021 27.3334H4.99785C3.45101 27.3334 2.4897 25.6526 3.27398 24.3193L14.2761 5.61572ZM16.5746 6.29175C16.3168 5.85354 15.6831 5.85354 15.4253 6.29175L4.42322 24.9953C4.1618 25.4398 4.48224 26 4.99785 26H27.0021C27.5177 26 27.8381 25.4398 27.5767 24.9953L16.5746 6.29175Z",
    fill: "#CE9C0C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.4e6cbb62d2d583ac6ed2f892279ec0ab.svg";
export { ForwardRef as ReactComponent };